import { createReducer, on } from "@ngrx/store";
import { Certificate } from "src/app/shared/interfaces/certificate";
import { HttpErrorResponse } from "@angular/common/http";
import {
  certificatesLoad,
  certificatesLoadFail,
  certificatesLoadSuccess,
} from "../actions/certificates.actions";

export interface CertificatesState {
  certificates: Certificate[];
  error: HttpErrorResponse | null;
  loading: boolean;
}

const initialState: CertificatesState = {
  certificates: [],
  error: null,
  loading: false,
};

export const certificatesReducer = createReducer(
  initialState,
  on(
    certificatesLoad,
    (state): CertificatesState => ({
      ...state,
      error: null,
      loading: true,
    }),
  ),
  on(
    certificatesLoadSuccess,
    (state, action): CertificatesState => ({
      ...state,
      certificates: action.certificates,
      error: null,
      loading: false,
    }),
  ),
  on(
    certificatesLoadFail,
    (state, { error }): CertificatesState => ({
      ...state,
      error,
      loading: false,
    }),
  ),
);
